import { httpRequest } from "../../../utils/HttpRequest";
import { IPage } from "../../../types/FmsTypes";
import { IAppUsage, IMdLogDetail, IMdLogFields, IMdLogSearch, IOneLineFields } from "./LogTypes";
import { IMdAppDetail } from "../app/AppTypes";


class LogService {


    /**
     * 分页查询日志
     * @param params 
     * @returns 
     */
    async page(params: IMdLogSearch) {
        const logUrl = "/log/login/findPage";
        return await httpRequest.post<IPage<IMdLogDetail>>(logUrl, params);
    }

    /**
     * 查询单条日志
     * @param id
     * @returns 
     */
    async findOne(id: string) {
        const logUrl = `/log/login/findOne/${id}`;
        return await httpRequest.post<IMdLogDetail>(logUrl);
    }

    /**
     * 查询当前在线用户和用户总数
     * @returns 
     */
    async onLineUser() {
        const logUrl = `/log/appAccess/onlineUser/`;
        return await httpRequest.post<IOneLineFields>(logUrl);
    }

    /**
     * 查询当前用户可访问应用
     * @returns 
     */
    async showUserApp(userCode: string) {
        const logUrl = `/log/appAccess/showMyApp/${userCode}`;
        return await httpRequest.post<IMdAppDetail[]>(logUrl);
    }

    /**
     * 用户登入日志记录
     * @returns 
     */
    async appLogin(userCode: string) {
        const logUrl = `/log/appAccess/recordAppLoginInfo/portal/${userCode}`;
        return await httpRequest.post<Boolean>(logUrl);
    }

    /**
     * 用户登出日志记录
     * @returns 
     */
    async appLogout(userCode: string) {
        const logUrl = `/log/appAccess/recordAppLogoutInfo/portal/${userCode}`;
        return await httpRequest.post<Boolean>(logUrl);
    }

    /**
     * 查询应用统计信息(本日)
     * @returns 
     */
    async appUsageToday() {
        const logUrl = `/log/appAccess/appUsageToday`;
        return await httpRequest.post<IAppUsage[]>(logUrl);
    }

    /**
     * 查询应用统计信息(本周)
     * @returns 
     */
    async appUsageWeek() {
        const logUrl = `/log/appAccess/appUsageWeek`;
        return await httpRequest.post<IAppUsage[]>(logUrl);
    }

    /**
     * 查询应用统计信息(本月)
     * @returns 
     */
    async appUsageMouth() {
        const logUrl = `/log/appAccess/appUsageMouth`;
        return await httpRequest.post<IAppUsage[]>(logUrl);
    }

    /**
     * 查询应用统计信息(本年)
     * @returns 
     */
    async appUsageYear() {
        const logUrl = `/log/appAccess/appUsageYear`;
        return await httpRequest.post<IAppUsage[]>(logUrl);
    }



}

export const logService = new LogService();
